import { render } from "./afis_form.html?vue&type=template&id=2ab80884&external"
import script from "./afis_form.js?vue&type=script&lang=js&external"
export * from "./afis_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__